<template>
  <div>
    <h1>Playlist Tips</h1>
    <v-layout>
      <v-text-field v-model="name" solo label="Title"></v-text-field>
      <v-select
        style="margin-left: 10px;"
        label="Type"
        v-model="type"
        :items="[
          {
            value: '1',
            label: 'Action',
          },
          {
            value: '2',
            label: 'Idea',
          },
          
        ]"
        item-text="label"
        item-value="value"
      ></v-select>
    </v-layout>
    <v-layout>
      <v-text-field v-model="description" solo label="Description"></v-text-field>
      <v-btn :disabled="(name != null && name != '' && description != null && description != '' && type != null && type != '') ? false : true" @click="createGoal" text
        color="success">add new tip</v-btn>
    </v-layout>
    <v-layout>
      <v-text-field @input="seatchMethod" v-model="search" solo label="Search"></v-text-field>
    </v-layout>
    <v-layout v-if="tips != null">
      <v-data-table v-if="tips.length" :headers="[
        /* { text: 'NUMBER', value: 'id_playlist' }, */
        { text: 'INDEX ORDER', value: 'index_order' },
        { text: 'NAME', value: 'name' },
        { text: 'TYPE', value: 'check_type' },
        { text: 'COUNT LIKE', value: 'count' },
        { text: 'EDIT', value: 'edit' },
        { text: 'DELETE', value: 'actions' },


      ]" :items="filteredTips">
        <template v-slot:item.actions="{ item }">
          <v-btn @click="deleteItem(item)" text color="error">DELETE</v-btn>
        </template>
        <template v-slot:item.check_type="{ item }">
          {{ item.type == 1 ? 'Action' : 'Idea' }}
        </template>
        <template v-slot:item.edit="{ item }">
          <v-btn @click="edit(item)" text color="info">Edit</v-btn>
        </template>
      </v-data-table>
      <v-dialog v-model="dialog" v-if="selected != null" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            Updating
          </v-card-title>

          <v-card-text>
            <v-text-field v-model="selected.name" label="Title"></v-text-field>
            <v-select
            label="Type"
            v-model="selected.type"
            :items="[
              {
                value: '1',
                label: 'Action',
              },
              {
                value: '2',
                label: 'Idea',
              },
              
            ]"
            item-text="label"
            item-value="value"
          ></v-select>
          </v-card-text>
          <v-card-text>
            <v-text-field v-model="selected.description" label="Description"></v-text-field>
          </v-card-text>
          <v-card-text>
            <v-text-field v-model="selected.index_order" label="Index order"></v-text-field>
          </v-card-text>

          <v-card-text>
            <img v-if="selected.img_preview!=null && selected.img_preview!=''" width="300px" height="180px" :src="selected.img_preview" style="margin-bottom: 20px;"/>
            <input v-show="false" ref="preview" type="file" accept="image/*" @change="updatePreview">
            <v-btn style="margin: 5px;width: 200px;" small color="info" @click="$refs.preview.click()" :loading="loading.img">
            Upload preview / image
          </v-btn>
          <v-btn style="margin: 5px;width: 200px;" small color="error" @click="deleteImage">
            Delete preview / image
          </v-btn>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            <video style="max-width: 300px !important; height: 180px; margin-bottom: 20px;" controls v-if="selected.video!=null && selected.video!=''" :src="selected.video"></video>
            <input v-show="false" ref="video" type="file" accept="video/*" @change="updateVideo">
            <v-btn style="margin: 5px;width: 200px;" small color="info" @click="$refs.video.click()" :loading="loading.video">
            Video upload
          </v-btn>
          <v-btn style="margin: 5px;width: 200px;" small color="error" @click="deleteVideo">
            Delete video
          </v-btn>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            <div class="display-1 mb-2">
              Credit
              <v-icon @click="deleteAuthor">delete</v-icon>
            </div>
            <v-divider />
            <span v-if="selected.user"> Applied credit: {{ selected.user.name +' '+ selected.user.surname }}</span>
            <v-divider />
            <v-layout row align-start class="pt-4">
              <v-text-field @input="searchUser" label="User name" v-model="user" type="text" solo></v-text-field>
              <v-select label="User" v-model="selected.id_author" :items="users" item-text="name" item-value="id_user"
                solo></v-select>
            </v-layout>
            <v-layout row align-start class="pt-4">
              <v-text-field label="Social link" v-model="selected.social" type="text" solo></v-text-field>
            </v-layout>
          </v-card-text>


          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" flat @click="update">
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios';
import CryptoJS from "crypto-js";
import { Base64 } from 'js-base64';
export default {
  data() {
    return {
      name: null,
      type:null,
      description: null,
      tips: null,
      filteredTips: null,
      search: '',
      selected: null,
      user:'',
      users:null,
      dialog: false,
      loading:{
        img:false,
        video:false
      }
    }
  },
  methods: {
    encryptObject(data) {
      const key = CryptoJS.enc.Utf8.parse(process.env['VUE_APP_SECURE_KEY']);
      const iv = CryptoJS.lib.WordArray.random(16);
      const ivBase64 = CryptoJS.enc.Base64.stringify(iv);

      const objectToEncryptString = JSON.stringify(data);

      const encrypted = CryptoJS.AES.encrypt(objectToEncryptString, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        keySize: 256 / 8,
      });

      const encryptedObject = {
        iv: ivBase64,
        value: encrypted.ciphertext.toString(CryptoJS.enc.Base64),
      };
      return encryptedObject;
    },
    decryptData(res) {
      var key = process.env["VUE_APP_SECURE_KEY"];
      var encrypted = res.payload;
      var encrypted_json = JSON.parse(Base64.decode(encrypted));
      var decrypted = CryptoJS.AES.decrypt(encrypted_json.value, CryptoJS.enc.Base64.parse(Base64.encode(key)), {
        iv: CryptoJS.enc.Base64.parse(encrypted_json.iv),
        mode: CryptoJS.mode.CBC
      });
      let data = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));

      return data;
    },
    searchUser() {
      if (!this.user.length) return;
      axios.post('/user/search', this.encryptObject({
        name: this.user
      })).then(res => {
        let data = this.decryptData(res.data)
        this.users = data.map(n => {
          n.name = n.name + ' ' + n.surname;
          return n;
        });
        this.users.unshift({
          name: 'Empty',
          id_user: null,
        });
      });
    },
    deleteAuthor() {
      this.users = [];
      this.user = '';
      this.selected.id_author = null;
    },
    deleteImage()
    {
      let obj = {
          id_tip: this.selected.id
      }

            axios.post('/admin/tips/deleteImage', obj, {
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(res => {
              this.selected.img_preview = res.data.data;
            });
    },
    deleteVideo()
    {
      let obj = {
          id_tip: this.selected.id
      }

            axios.post('/admin/tips/deleteVideo', obj, {
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(res => {
              this.selected.video = res.data.data;
            });
    },
    updatePreview(event) {
      this.loading.img = true;
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
        reader.onload = () => {
            const base64Data = reader.result;
            let obj = {
                image: base64Data,
                id_tip: this.selected.id
            }

            axios.post('/admin/tips/setImage', obj, {
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(res => {
              this.selected.img_preview = res.data.data;
            }).finally(() => {
              this.loading.img = false;
            });
        };
        reader.readAsDataURL(file);
    },
    updateVideo(event) {
      var data = new FormData();
      this.loading.video = true;
      data.append('file', this.$refs.video.files[0]);
      axios.post('/admin/tips/' + this.selected.id + '/setVideo', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.selected.video = res.data.data;
      }).finally(() => {
        this.loading.video = false;
      });
    },
    async update() {
      if (this.selected.name != null && this.selected.name != "")
        await axios
          .post("/admin/tips/update", {
            id: this.selected.id,
            name: this.selected.name,
            type: this.selected.type,
            id_author: this.selected.id_author,
            social: this.selected.social,
            description: this.selected.description,
            index_order:this.selected.index_order
          }).then((res) => {
            this.dialog = false;
            this.sync();
          })
    },
    edit(item) {
      this.selected = Object.assign({}, item);
      this.dialog = true;
    },
    seatchMethod(val) {
      if (this.search == '') {
        this.filteredTips = this.tips.sort((a, b) => {
  if (a.index_order === 0 && b.index_order !== 0) {
    return 1; // Если у "a" index_order равен 0, а у "b" не равен 0, поместите "a" в конец
  } else if (a.index_order !== 0 && b.index_order === 0) {
    return -1; // Если у "b" index_order равен 0, а у "a" не равен 0, поместите "b" в конец
  } else {
    return a.index_order - b.index_order; // Иначе сортируйте по index_order от меньшего к большему
  }
});
      }
      else {
        this.filteredTips = this.tips.filter(element => {
          return (element.name).includes(this.search)
        });
      }
    },
    async createGoal() {
      if (this.name != null && this.name != "")
        await axios
          .post("/admin/tips/create", {
            name: this.name,
            description: this.description,
            type: this.type
          }).then(() => {
            this.sync();
            this.name = null;
            this.description = null;
            this.type = null;
          })
    },
    async deleteItem(item) {
      await axios
        .post("/admin/tips/delete", item).then(() => {
          this.sync();
        })
    },
    async sync() {
      await axios
        .get("/admin/tips/get").then((res) => {
          this.tips = res.data.data.sort((a, b) => {
  if (a.index_order === 0 && b.index_order !== 0) {
    return 1; // Если у "a" index_order равен 0, а у "b" не равен 0, поместите "a" в конец
  } else if (a.index_order !== 0 && b.index_order === 0) {
    return -1; // Если у "b" index_order равен 0, а у "a" не равен 0, поместите "b" в конец
  } else {
    return a.index_order - b.index_order; // Иначе сортируйте по index_order от меньшего к большему
  }
});

          this.filteredTips = res.data.data.sort((a, b) => {
  if (a.index_order === 0 && b.index_order !== 0) {
    return 1; // Если у "a" index_order равен 0, а у "b" не равен 0, поместите "a" в конец
  } else if (a.index_order !== 0 && b.index_order === 0) {
    return -1; // Если у "b" index_order равен 0, а у "a" не равен 0, поместите "b" в конец
  } else {
    return a.index_order - b.index_order; // Иначе сортируйте по index_order от меньшего к большему
  }
});
        })
    },
  },
  created() {
    this.sync();
  }
}
</script>
<style lang="scss" scoped></style>